import { QueryState } from 'common/enums';
import { Nullable } from 'common/utils/Nullable';
import { IChecklistResponseToSave } from 'interfaces/checklist.interface';

export interface IResponsesState {
  state: QueryState;
  responses: IChecklistResponseToSave[];
  error: Nullable<string>;
  accessToken: string | undefined;
}

export const ChecklistResponsesEmptyState: IResponsesState = {
  state: QueryState.UNDEFINED,
  responses: [],
  error: null,
  accessToken: undefined
};
